// extracted by mini-css-extract-plugin
export var printerCard = "_a8-1";
export var printerCardConfigured = "_a8-2";
export var printerCardError = "_a8-3";
export var printerCardsContainer = "_a8-0";
export var printerIcon = "_a8-8";
export var printerIconConfigured = "_a8-5";
export var printerIconContainer = "_a8-4";
export var printerIconError = "_a8-6";
export var printerIconUnconfigured = "_a8-7";